
export const UPDATE_ADMIN_PROFILE = 'UPDATE_ADMIN_PROFILE' ;
export const UPDATE_TEACHER_PROFILE = 'UPDATE_TEACHER_PROFILE' ;
export const UPDATE_STUDENT_PROFILE = 'UPDATE_STUDENT_PROFILE' ;
export const LOGOUT_USER = 'LOGOUT_USER' ;
export const MODIFY_LOGIN_STATUS = 'MODIFY_LOGIN_STATUS' ;
export const DISPLAY_RESET_PASSWORD_FORM = 'DISPLAY_RESET_PASSWORD_FORM'
export const HIDE_RESET_PASSWORD_FORM = 'HIDE_RESET_PASSWORD_FORM';

